import cn from 'classnames';

import { ImageData, LinkData } from 'src/types/components';

import Breadcrumbs from '../Breadcrumbs';
import Cta from '../Cta';
import Image from '../Image';
import Link from '../Link';
import PatternBackground from '../PatternBackground';
import Text from '../Text';

import styles from './ArticleHero.module.scss';

export type ArticleHeroProps = {
  eyebrow?: string;
  title: string;
  subhead?: string;
  date?: string;
  links?: Array<LinkData>;
  cta?: LinkData;
  image?: ImageData;
  breadcrumbs: Array<LinkData>;
};

const ArticleHero = (props: ArticleHeroProps): JSX.Element => {
  const { eyebrow, title, subhead, date, links, cta, image, breadcrumbs } = props;

  return (
    <div className={styles.main} data-component="ArticleHero">
      {image ? (
        <>
          <Image className={styles.image} {...image} fill data-component="hero-image" />
          <div className={styles.overlay} />
        </>
      ) : (
        <PatternBackground
          className={styles.pattern}
          size="medium"
          theme="dark"
          fetchPriority="high"
        />
      )}
      <div className={cn(styles.container, 'container-10')}>
        <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={breadcrumbs} />
        {eyebrow && <Text className={cn(styles.eyebrow, 'body-eyebrow')} field={eyebrow} />}
        <Text tag="h1" className={cn(styles.title, 'heading-h2')} field={title} />
        {subhead && <Text className={styles.subhead} field={subhead} />}
        {Boolean(date || (links && links.length) || (cta && cta.href)) && (
          <div className={styles.meta}>
            {date || (links && links.length) ? (
              <div className={styles.left}>
                {date && <Text className={cn(styles.date, 'body-eyebrow')} field={date} />}
                {links &&
                  links.map((link, index) => (
                    <Link
                      key={`link-${index}`}
                      {...link}
                      className={cn(styles.link, 'body-eyebrow')}
                    >
                      {link.label}
                    </Link>
                  ))}
              </div>
            ) : (
              <div></div>
            )}
            {cta?.href && (
              <Cta
                tag="a"
                className={styles.cta}
                openNewTab={cta.target === '_blank'}
                {...cta}
                theme={image ? 'filled' : 'dark'}
              >
                {cta.label || cta.href}
              </Cta>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleHero;
